var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"pkdoIltr0K3RGcZXqN79D"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/transportation-build/ee8a236c27d260e1a00add57ce4ec77a9a2d66b4";

import * as Sentry from '@sentry/nextjs';

const env = process.env.NEXT_PUBLIC_TARGET_ENV || 'development';
const isProduction = env === 'production';
const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

if (isProduction) {
  Sentry.init({
    dsn:
      SENTRY_DSN ||
      'https://584d691c5e14c03a16d2067065ac2c91@o249654.ingest.us.sentry.io/4508845056917504',
    environment: env,
    tracesSampleRate: 1.0,
  });
}
